import { Button, Modal } from 'react-bootstrap';
import useT from '../../i18n/useT';

const CreateNews = ({ formData, setFormData, show, setShow, submit, type, loading }) => {
    const t = useT();
    return (
        <Modal show={show} onHide={() => setShow(false)} centered size='lg'>
            <Modal.Header closeButton><h3>{type === "edit" ? t("news.modifyNews") : t("news.addNews")}</h3></Modal.Header>
            <Modal.Body>
                <form onSubmit={submit} className='row'>
                    <div className='col-md-8 mt-3'>
                        <div className='form-group'>
                            <label>{t("news.newsTitle")}</label>
                            <input type='text' placeholder={t("news.enterTitle")} className='form-control' value={formData.title || ""} onChange={(e) => setFormData((prev) => ({ ...prev, title: e.target.value }))} />
                        </div>
                    </div>
                    <div className='col-md-4 mt-3'>
                        <div className='form-group'>
                            <label>{t("news.priority")}</label>
                            <select className='form-control' value={formData.priority || ""} onChange={(e) => setFormData((prev) => ({ ...prev, priority: e.target.value }))}>
                                <option value="">{t("news.selectPriority")}</option>
                                <option value="low">{t("news.prLow")}</option>
                                <option value="medium">{t("news.prMedium")}</option>
                                <option value="high">{t("news.prHigh")}</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-md-12 mt-3'>
                        <div className='form-group'>
                            <label>{t("news.message")}</label>
                            <textarea rows={6} placeholder={t("news.enterMessage")} className='form-control' value={formData.message || ""} onChange={(e) => setFormData((prev) => ({ ...prev, message: e.target.value }))} />
                        </div>
                    </div>
                    <div className='col-md-12 mt-4'>
                        <Button type='submit' disabled={loading} style={{ width: "100%" }}>
                            {loading ? <div className="spinner-border spinner-border-sm text-light" role="status"></div> : (type === "edit" ? t("common.save") : t("news.publish"))}
                        </Button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default CreateNews;
